import { ExpressionValidationResultDc } from "@evergis/api";
import { createAction, createReducer } from "redux-act";
import { reducerRegistry } from "../reducerRegistry";

const reducerName = "validation";

export type ValidationState = {
  error?: Error | null;
  serverError?: ExpressionValidationResultDc | null;
};

const initialState: ValidationState = {};

export const setValidationError = createAction<Error | null>("validation/set-validation-error");

export const setValidationServerError = createAction<ExpressionValidationResultDc | null>(
  "validation/set-validation-server-error",
);

export const reducer = createReducer({}, initialState);

reducer.on(setValidationError, (state, error) => ({ ...state, error }));

reducer.on(setValidationServerError, (state, serverError) => ({ ...state, serverError }));

reducerRegistry.register(reducerName, reducer);
